export const contentDict = {
  title: "Terminal-like Personal Website",                // Display name
  finishDate: new Date("2022-07-30"),     // format is YYYY-MM-DD
  tools: {                                // Dict of languages and percentages (should add up to 1)
    "JavaScript": 0.5,
    "HTML": 0.3,
    "CSS": 0.2,
  }, 
  description: 
    `A personal website where the visitor retrieves information by interacting with a command line.
    I particularly like the code completion feature.`,
  tags: ["Webdev"],
  github: "https://github.com/philippwulff/pw-term",    // Can also be `null`
  website: "https://philippwulff.github.io/pw-term/",       // Can also be `null`
  images: [
    require('./website-laptop.mov'),
  ],
  coverImg: require('./website.jpg'),
  mainColor: "#25537a",
  authors: ["Philipp Wulff"],
  isResearch: false,    // Whether this should be in the research section
};

// export default contentDict;
// module.exports = { contentDict: 'contentDict' }